import { expenseRepository } from '@webapp/modules/expense/data-access/repositories/ExpenseRepository'
import { GetExpenseItemAccountBudgetPeriodUseCase } from './GetExpenseItemAccountBudgetPeriodUseCase'

export const getExpenseItemAccountBudgetPeriodUseCase =
  new GetExpenseItemAccountBudgetPeriodUseCase({
    expenseRepository,
  })

export { GetExpenseItemAccountBudgetPeriodUseCase } from './GetExpenseItemAccountBudgetPeriodUseCase'
